import PropTypes from 'prop-types'
import _ from 'lodash'
import createReactClass from 'create-react-class'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ValidationBox, Input } from 'legacy/libs/react-form-tools'
import Select from 'legacy/libs/components/select'
import sourceTexts from 'legacy/libs/components/source-text'
import { getFullName } from 'legacy/account/utils'
import { withGettext } from 'lib/gettext'
import ChooseExpert from './choose-expert'

const EntrySourceSelect = createReactClass({
  mixins: [SchemaBranchMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
    entrySourcesList: PropTypes.arrayOf(PropTypes.object),
    secondarySourcesList: PropTypes.arrayOf(PropTypes.object),
  },

  schema: {
    entrySource: null,
    secondarySource: null,
    otherSecondarySourceName: '',
    entrySourceExpertPk: null,
    expertSource: null,
    supervisedBy: null,
    initialExpert: null,
  },

  componentDidMount() {
    if (!this.state.entrySource) {
      const firstEntrySourceSlug = _.first(this.props.entrySourcesList).slug
      this.cursors.entrySource.set(firstEntrySourceSlug)
    }

    if (!this.state.secondarySource) {
      this.cursors.secondarySource.set(_.first(this.props.secondarySourcesList))
    }

    if (this.state.entrySource === 'expert') {
      this.initExpertField(this.state.expertSource)
    } else if (this.state.entrySource === 'supervised') {
      this.initExpertField(this.state.supervisedBy)
    }
  },

  initExpertField(expert) {
    if (_.isPlainObject(expert)) {
      this.cursors.entrySourceExpertPk.set(expert.pk)
      this.cursors.initialExpert.set({
        label: getFullName(expert.user),
        value: expert.pk,
      })
    }
  },

  render() {
    const { gettext } = this.props
    const options = _.map(this.props.entrySourcesList, (entrySource) => ({
      label: gettext(entrySource.name),
      value: entrySource.slug,
    }))
    const { entrySource, secondarySource } = this.state
    const currentNoteText = gettext(sourceTexts[entrySource])

    const secondarySourceOptions = [
      ..._.map(this.props.secondarySourcesList, (secondarySourceItem) => ({
        label: secondarySourceItem.title,
        value: secondarySourceItem.pk,
      })),
      {
        label: gettext('Other...'),
        value: 0,
      },
    ]

    return (
      <div className="grid gap-4 sm:grid-cols-2 sm:gap-6 md:gap-8">
        <div className="space-y-4">
          <ValidationBox fieldPath="entrySource">
            <label className="mb-2 block text-default-light">
              {gettext('Entry source')}
            </label>

            <Select options={options} />
          </ValidationBox>

          {entrySource === 'secondary' && (
            <>
              <ValidationBox fieldPath="secondarySource.pk">
                <label className="mb-2 block text-default-light">
                  {gettext('Secondary source')}
                </label>

                <Select options={secondarySourceOptions} />
              </ValidationBox>

              {secondarySource.pk === 0 && (
                <ValidationBox fieldPath="otherSecondarySourceName">
                  <Input
                    className="input"
                    maxLength="140"
                    placeholder={gettext('New secondary source')}
                  />
                </ValidationBox>
              )}
            </>
          )}

          {(entrySource === 'expert' || entrySource === 'supervised') && (
            <ValidationBox fieldPath="entrySourceExpertPk">
              <ChooseExpert
                userPkCursor={this.cursors.entrySourceExpertPk}
                initialExpertCursor={this.cursors.initialExpert}
              />
            </ValidationBox>
          )}
        </div>

        <p className="text-xs text-default-light sm:pt-6">{currentNoteText}</p>
      </div>
    )
  },
})

export default withGettext(EntrySourceSelect)
